// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__370jT","notes":"Notes_notes__2XAK1","note":"Notes_note__2thXV","markdown":"Notes_markdown__1mj5-"};